import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Orders = {
  Helmet: lazy(() => import('./components/OrdersHelmet')),
  DigitalPositions: lazy(() => import('./containers/DigitalPositions')),
  DigitalPositionsV2: lazyNamed(() => import('./containers/DigitalPositionsV2'), 'DigitalPositionsV2'),
  PrintPositions: lazy(() => import('./containers/PrintPositions')),
  PrintPositionsV2: lazyNamed(() => import('./containers/PrintPositionsV2'), 'PrintPositionsV2'),
  ProgrammaticDeals: lazy(() => import('./containers/ProgrammaticDeals').then(({ ProgrammaticDeals }) => ({ default: ProgrammaticDeals }))),
  PositionHistory: {
    Component: lazy(() => import('./containers/PositionHistory')),
    Providers: lazy(() => import('./containers/PositionHistory/components/Providers')),
  },
  Forecast: lazyNamed(() => import('./containers/Forecast'), 'Forecast'),
  Broadcast: lazy(() => import('./containers/Broadcast')),
  BroadcastPositionsV2: lazyNamed(() => import('./containers/BroadcastPositionsV2'), 'BroadcastPositionsV2'),
  Booking: lazyNamed(() => import('./containers/Booking'), 'Booking'),
  Comments: lazy(() => import('./containers/Comments')),
  Campaigns: {
    CampaignsList: lazyNamed(() => import('./containers/Campaigns/pages/CampaignsList'), 'CampaignsList'),
    Order: lazyNamed(() => import('./containers/Campaigns/pages/Order'), 'Order'),
  },
  PointOfSalePositions: lazyNamed(() => import('./containers/PointOfSalePositions'), 'PointOfSalePositions'),
};

export default Orders;
